import { useWatch } from 'react-hook-form';
import { DateInput } from 'v5/design-system/DateInput';
import { FormField } from 'v5/design-system/Form';
import { dateConvert } from 'v5/platform/lang/dateConvert';
import { useFieldContext } from '../FieldContext';
import { EmptyField } from './EmptyField';
import { FieldControlBase } from './FieldControlBase';
import type { FieldFrameSpec, FieldPartProps } from './fieldComponent.types';

/**
 * Single local date or `null`. The form
 * holds a `Date` (the codec's value); the input takes a `CalendarDate`.
 */
export function DateField({
  spec,
  path,
  hideLabel
}: FieldPartProps<FieldFrameSpec>) {
  const ctx = useFieldContext();
  const readOnly = ctx.mode === 'display';
  const date: Date | null = useWatch({ name: path }) ?? null;

  if (readOnly && date === null) {
    return <EmptyField spec={spec} path={path} hideLabel={hideLabel} />;
  }

  return (
    <FormField
      name={path}
      render={({ field }) => (
        <FieldControlBase spec={spec} hideLabel={hideLabel}>
          <DateInput
            className="w-full"
            variant={ctx.variant}
            size={ctx.size}
            readOnly={readOnly}
            aria-label={spec.label}
            value={dateConvert.calendarDate.from(field.value ?? null)}
            onChange={value =>
              field.onChange(dateConvert.calendarDate.toLocalDate(value))
            }
          />
        </FieldControlBase>
      )}
    />
  );
}
